export default {"src":"/_next/static/media/integration-icon.c2ab1d16.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};